import { Component } from '@angular/core';
import { CrudSavePopupComponent } from '../_directives';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CampaignService, UserService } from '../_services';
import { FormBuilder, Validators } from '@angular/forms';
import * as moment from 'moment-timezone';
import { takeUntil } from 'rxjs/operators';
import { ShowBreadcrumbs, User } from '../_models';

@Component({
  selector: 'app-campaign-new-popup',
  templateUrl: './campaign-new-popup.component.html',
})
export class CampaignNewPopupComponent extends CrudSavePopupComponent {
  objectName = 'Brand';
  title = 'New Brand';
  showSuccessMessage = false;
  timezones: string[] = [];
  domain: string = '';

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected campaignService: CampaignService,
    protected alertService: AlertService,
    protected formBuilder: FormBuilder,
    protected userService: UserService
  ) {
    super(router, location, route, campaignService, alertService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.formBuilder.group({
      name: [null, Validators.required],
      subdomain: [null, Validators.required],
      timezone: [moment.tz.guess(), Validators.required],
      display_name: [null],
      
      // Default settings for new campaigns
      mouseflow_enabled: [true],
      show_breadcrumbs: [ShowBreadcrumbs.Never],
      portal_settings: this.formBuilder.group({
        auto_select_single_item: [true],
      }),
    });

    const usSlashTimezones = moment.tz.names().filter((tz) => tz.startsWith('US/'));
    const americaTimezones = moment.tz.names().filter((tz) => tz.startsWith('America/'));
    const otherTimezones = moment.tz.names().filter((tz) => !tz.startsWith('US/') && !tz.startsWith('America/'));

    // Sort each group alphabetically and combine: US/ first, then America/, then others
    this.timezones = [...usSlashTimezones.sort(), ...americaTimezones.sort(), ...otherTimezones.sort()];

    this.userService
      .getCurrent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (user: User) => {
          this.domain = user.account.domain;
        },
        (error) => {
          this.handleError(error);
        }
      );
  }

  checkSubdomain(event) {
    if (event.target.value) {
      let subdomain = event.target.value.trim().toLowerCase();

      if (subdomain.length) {
        this.campaignService
          .checkSubdomain(subdomain)
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            () => {},
            (error) => {
              this.handleSubmitError(error);
            }
          );
      }
    }
  }
}
